import React from 'react';

import { selectFiles } from '../../../core/services/file.service';

import styles from './edit-cover.button.module.scss';
type EditCoverButtonProps = {
  onChange: (file: File) => void;
};

export const EditCoverButton: React.FC<EditCoverButtonProps> = ({ onChange }) => {
  const handleChange = async () => {
    const files = await selectFiles({ accept: 'image/png, image/webp, image/jpeg' });

    if (!files || files.length === 0) {
      return;
    }

    onChange(files[0]);
  };

  return (
    <div className={styles['edit-cover']} data-edit-cover onClick={handleChange}>
      Edit
    </div>
  );
};
